
import { TableSortLabel,MenuItem} from '@mui/material';

export default function TableSortMenu(param,item,handleClose: any, order: string) {
    const onSortLoadData = (order) => {
        let sSort = order;
        item.order = sSort;
        item.orderactive = true;
        let cloneData = { ...param.rows};
        cloneData.sSortExpression = item.field;
        cloneData.sSortDirection = sSort;
        handleClose() 
        param.onLoadData(cloneData);
        
    } 
    return <MenuItem onClick={() => { onSortLoadData(order)}} autoFocus={false}>
        <TableSortLabel
            active={true}
            direction={order === 'asc' ? 'asc' : 'desc'}
            spellCheck={true}
        >
        </TableSortLabel>  {order === 'asc' ? ' Sort by ASC' : ' Sort by DESC'}
    
    </MenuItem>
}